var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMageMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46264 21.97C11.3094 21.97 13.0805 21.2363 14.3863 19.9305C15.6921 18.6247 16.4258 16.8536 16.4258 15.0068C16.4258 13.1601 15.6921 11.389 14.3863 10.0832C13.0805 8.77731 11.3094 8.0437 9.46264 8.0437C7.6159 8.0437 5.8448 8.77731 4.53896 10.0832C3.23312 11.389 2.49951 13.1601 2.49951 15.0068C2.49951 16.8536 3.23312 18.6247 4.53896 19.9305C5.8448 21.2363 7.6159 21.97 9.46264 21.97ZM20.6426 21.4287C22.5326 21.4287 24.0651 18.5537 24.0651 15.0062C24.0651 11.4587 22.5326 8.58495 20.6426 8.58495C18.7526 8.58495 17.2201 11.46 17.2201 15.0062C17.2201 18.5537 18.7526 21.4287 20.6426 21.4287ZM26.1526 20.755C26.8901 20.755 27.4864 18.18 27.4864 15.0062C27.4864 11.8325 26.8889 9.2587 26.1526 9.2587C25.4151 9.2587 24.8176 11.8325 24.8176 15.0062C24.8176 18.1812 25.4151 20.755 26.1526 20.755Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageMedium);
export default __webpack_public_path__ + "static/media/mage_medium.df55952d1080f58d3f67a191f540640d.svg";
export { ForwardRef as ReactComponent };